<template>
    <div class="artifact-header">
        <div class="artifact-header__group">
            <slot name="left" />
        </div>
        <div class="artifact-header__group">
            <slot name="right" />
            <div class="artifact-header__default-items">
                <ask-pendo-toolbar-menu
                    v-if="menuItems && menuItems.length"
                    icon="more-horizontal"
                    placement="bottom-end"
                    :items="menuItems" />
                <pendo-icon-button
                    v-if="isPreviewExpandable"
                    :tooltip="isInline ? $t('Open') : $t('Close')"
                    :icon="toggleIcon"
                    @click="$emit('toggle')" />
            </div>
        </div>
    </div>
</template>

<script>
import { PendoIconButton } from '@pendo/components';
import AskPendoToolbarMenu from '@/ask-pendo/components/ask-pendo-toolbar-menu.vue';

export default {
    name: 'AskPendoArtifactHeader',
    components: {
        PendoIconButton,
        AskPendoToolbarMenu,
    },
    props: {
        isInline: {
            type: Boolean,
            default: false,
        },
        isPreviewExpandable: {
            type: Boolean,
            default: true,
        },
        menuItems: {
            type: Array,
            default: () => [],
        },
    },
    emits: ['toggle'],
    computed: {
        toggleIcon () {
            return this.isInline ? 'maximize-2' : 'minimize-2';
        },
    },
};
</script>

<style scoped lang="less">
.artifact-header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    padding: 8px 16px;
    border-bottom: 1px solid var(--palette-gray-40);
    background-color: var(--palette-gray-0);

    &__group {
        display: flex;
        align-items: center;
        gap: 8px;
    }

    &__default-items {
        display: flex;
        align-items: center;
    }
}
</style>
